import { atom, selector, useRecoilState, useResetRecoilState } from 'recoil';

/**
 * 공장 목록
 */
// atom
const plantState = atom({
  key: 'plantState',
  default: {
    alls: [],
    hasReads: [],
    hasMods: [],
    koreas: []
  }
});

// selector
const plantSelector = selector({
  key: 'plantSelector',
  get: ({ get }) => get(plantState),
  set: ({ set }, newValue) =>
    set(plantState, prevState => ({ ...prevState, ...newValue }))
});

// hook
function usePlantState() {
  const [plant, setPlant] = useRecoilState(plantSelector);
  const resetPlant = useResetRecoilState(plantState);

  return {
    plant,
    setPlant,
    resetPlant
  };
}

export default usePlantState;
